module.exports = __webpack_public_path__ + "8ce993fa1441a33de5a1104cdecbd394.jpg";